/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AttachmentScope } from '../../models/attachment-scope';
import { StorageObjectDto } from '../../models/storage-object-dto';

export interface UploadFile$Params {
  assetId?: string | null;
  scope: AttachmentScope;
  draft?: boolean | null;
  tags?: Array<string>;
      body: {
'file': Blob;
}
}

export function uploadFile(http: HttpClient, rootUrl: string, params: UploadFile$Params, context?: HttpContext): Observable<StrictHttpResponse<StorageObjectDto>> {
  const rb = new RequestBuilder(rootUrl, uploadFile.PATH, 'post');
  if (params) {
    rb.query('assetId', params.assetId, {});
    rb.query('scope', params.scope, {});
    rb.query('draft', params.draft, {});
    rb.query('tags', params.tags, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StorageObjectDto>;
    })
  );
}

uploadFile.PATH = '/v0/storageObjects';
